module.exports = __webpack_public_path__ + "img/hongkong,china.0621e4d5.png";